import React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';

import PropTypes from 'prop-types';
import { Container, Inner } from './styles';

export default function Section06({ id }) {
  var acc = document.getElementsByClassName('accordion');
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }

  return (
    <Container id={id}>
      <Inner>
        <h2>
          Perguntas <span>Frequentes</span>
        </h2>

        <Accordion defaultActiveKey="0">
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
              1 – O que é destinação de Imposto de Renda?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>É quando o contribuinte decide destinar parte do seu Imposto de
              Renda Devido (valor que ele pagou ou deve pagar ao Governo)
              diretamente para projetos de uma organização social.{' '}</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="1">
              2 – Qualquer projeto pode receber destinação de IR?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body> Não, apenas projetos aprovados pelos Conselhos específicos, ou
              seja, que passaram por criterioso processo de avaliação e estão
              certificados a receber a destinação.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="2">
              3 – Qualquer contribuinte pode destinar IR?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="2">
              <Card.Body> Não, apenas as pessoas físicas que preenchem o Formulário Completo
              na Declaração Anual de Imposto de Renda.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="3">
              4 – É preciso ser docente, funcionário ou aluno da PUC-SP e do Centro Universitário Assunção para destinar aos projetos?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="3">
              <Card.Body> Não, qualquer pessoa física que preenche pelo Formulário Completo pode destinar aos nossos projetos. Convide seus contatos a fazer parte dessa Campanha!</Card.Body>
            </Accordion.Collapse>
          </Card>
          
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="4">
              5 – Qual a porcentagem que eu posso destinar?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="4">
              <Card.Body> Você pode fazer 2 (duas) destinações:<br/>
                3% para um projeto de Criança e Adolescente + 3% para um projeto de Pessoas Idosas, somando 6% do seu Imposto Devido destinado.
                Para saber o passo-a-passo, acesse: <a href="www.pucsp.br/fundasp/incentive">www.pucsp.br/fundasp/incentive </a>

              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="5">
              6 – Eu terei algum custo extra ao destinar?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="5">
              <Card.Body> Não. Você terá retorno de 100% do valor destinado.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="6">
              7 – Eu tenho Imposto a Restituir. Posso destinar?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="6">
              <Card.Body> Sim, os valores destinados serão automaticamente somados ao valor a restituir, atualizado pela Taxa Selic. </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="7">
              8 – Eu tenho Imposto a Pagar. Posso destinar?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="7">
              <Card.Body> Sim, os valores destinados serão automaticamente subtraídos do valor a pagar.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="8">
              9 – Como calculo os valores exatos para ambas as destinações?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                A destinação é feita e calculada diretamente pelo Programa IRPF da Receita Federal, com segurança total.<br/>
                Após completar sua Declaração pelo Formulário Completo, o próprio Programa calcula e indica, em campo específico, os valores que você pode destinar.
                Ao gerar ambas as DARFs para pagamento, o programa automaticamente ajusta o valor a pagar ou a restituir da sua Declaração. É fácil e garantido.                 
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="9">
              10 – Eu completei minha Declaração, mas percebi que o valor indicado pelo Programa não é 3% do valor a pagar ou a restituir.
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="9">
              <Card.Body>Isso porque o cálculo de 3% é feito sobre o valor do Imposto Devido, que pode ser diferente do valor a pagar ou a restituir. Como o cálculo é automaticamente feito pelo próprio Programa, é confiável.
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="10">
              11 – Eu posso destinar um valor diferente do indicado pelo Programa?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="10">
              <Card.Body>Sim, qualquer valor abaixo do indicado pelo Programa será 100% revertido como incentivo fiscal.<br/>
              Você pode também pagar um valor maior. Neste caso, o valor indicado será revertido a você e o valor excedente será computado como doação ao projeto
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="11">
              12 – Como posso fazer a destinação?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="11">
              <Card.Body>A destinação é feita diretamente pelo Programa IRPF da Receita Federal.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="12">
              13 – Ainda tenho dúvidas, com quem posso falar?
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="12">
              <Card.Body>Com a Janaína Santos da Fundação São Paulo (Mantenedora da PUC-SP e do ASSUNÇÃO). <br/>E-mail: <a href="mailto:parcerias@fundasp.org.br">parcerias@fundasp.org.br</a> <br/>
				</Card.Body>
            </Accordion.Collapse>
          </Card>          
        </Accordion>
        
      </Inner>
    </Container>
  );
}
Section06.propTypes = {
  id: PropTypes.string,
};
